import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ErrorBoundary } from '@sentry/react';
import { Translate } from 'react-i18nify';
import moment from 'moment';
import { logout } from '../../actions';
import { clearStorage } from '../../services/sessionStorage';
import { DATE_FORMAT, LOGIN_AUTHORITY } from '../../constants';
import GenericErrorFallback from '../GenericErrorFallback';

const PrivateRoute = ({
  component: Component,
  namespace,
  authToken,
  authorities,
  requiredAuthority,
  redirectToReferrer,
  logout,
  ...rest
}) => {
  const isLoggedIn = () => {
    if (!authToken || !authToken.jwt || !authorities || authorities.indexOf(LOGIN_AUTHORITY) === -1) {
      return false;
    }

    const tokenExpiryDate = moment(authToken.expires, DATE_FORMAT);
    const now = moment();

    return now.isBefore(tokenExpiryDate);
  };

  const logOut = (props) => {
    clearStorage();
    logout();

    if (redirectToReferrer) {
      return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
    }

    window.location = '/login';

    return null;
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn() ? (
          <ErrorBoundary
            fallback={() => (
              <GenericErrorFallback>
                <Translate value="global.generic_error" />
              </GenericErrorFallback>
            )}
          >
            {requiredAuthority && !authorities.includes(requiredAuthority) ? (
              <div className="font-inter flex align-center justify-center h-100-vh">
                Du har inte tillgång till den här sidan.
              </div>
            ) : (
              <Component {...props} namespace={namespace} />
            )}
          </ErrorBoundary>
        ) : (
          logOut(props)
        )
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    authToken: state.auth.token,
    authorities: state.auth.authorities,
    redirectToReferrer: state.auth.redirectToReferrer
  };
};

const mapActionsToProps = {
  logout
};

export default withRouter(connect(mapStateToProps, mapActionsToProps)(PrivateRoute));
